import React from 'react'
export default function initiatives() {
    return (
        <div className="container-fluid rtl pb-5">
            <div className="container pt-5">
                <h1 className="block-title text-center title ">
                    مبادرات هاد </h1>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6 mb-auto ">
                        <div className="services-header mx-auto">
                            <div className="circles-container mb-5">
                                <div className="services-icon-circle5"></div>
                                <div className="services-icon-circle4">

                                    <img src="/assets/presentation.svg" className="icons" style={{ color: "white" }} alt="workshop" />
                                </div>

                                <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            </div>
                        </div>

                        <div className="services-body ">
                            عمل ورش عمل ودورات في مختلف المجالات التي تهم رائد الأعمال.
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="services-header">
                            <div className="circles-container mb-5">
                                <div className="services-icon-circle5"></div>
                                <div className="o-overlap-top__deco o-aspect-ratio"></div>
                                <div className="services-icon-circle4">
                                    <img src="/assets/manual.svg" className="icons" alt="instruction" />
                                </div>
                            </div>
                        </div>
                        <div className="services-body">
                            دليل إرشادي الكتروني بعنوان سؤال وجواب عن مشهد سوق العمل والأعمال.
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="services-header">
                            <div className="circles-container mb-5">
                                <div className="services-icon-circle5"></div>
                                <div className="o-overlap-top__deco o-aspect-ratio"></div>
                                <div className="services-icon-circle4">
                                    <img src="/assets/shining.svg" className="icons" alt="shining" />
                                </div>
                            </div>
                        </div>
                        <div className="services-body">
                            إبراز القدوات الوطنية
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}